import { create } from 'zustand'
import type { NotificationItem } from './notifications.types'

interface NotificationStoreState {
  notifications: NotificationItem[]
  unreadCount: number
  addNotification: (notification: NotificationItem) => void
  setNotifications: (notifications: NotificationItem[]) => void
  setUnreadCount: (count: number) => void
  markAllAsRead: () => void
}

export const useNotificationStore = create<NotificationStoreState>((set) => ({
  notifications: [],
  unreadCount: 0,

  addNotification: (notification) =>
    set((state) => ({
      notifications: [notification, ...state.notifications],
      unreadCount: state.unreadCount + 1,
    })),

  setNotifications: (notifications) => set({ notifications }),

  setUnreadCount: (count) => set({ unreadCount: count }),

  markAllAsRead: () =>
    set((state) => ({
      notifications: state.notifications.map((n) => ({ ...n, is_read: true })),
      unreadCount: 0,
    })),
}))

export const resetNotificationStore = () => {
  useNotificationStore.setState({ notifications: [], unreadCount: 0 })
}

// Selectors for convenience
export const useNotifications = () => useNotificationStore((state) => state.notifications)
export const useUnreadCount = () => useNotificationStore((state) => state.unreadCount)
